import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const ResponsibleGaming = () => (
  <LegalPageLayout title="Responsible Gaming" lastUpdated="August 2026">
    <p>
      WE R GAME is built for entertainment and skill-based prediction across sports tournaments. We encourage all users to
      play responsibly and within their means.
    </p>

    <h2>Know your limits</h2>
    <ul>
      <li>Only stake USDC you can afford to lose in Boost and Market modes.</li>
      <li>Free mode uses tickets and points — treat it as casual play, not income.</li>
      <li>Set a personal budget before participating in paid pools or orderbook trading.</li>
      <li>Take breaks. Streaks and leaderboards are for fun — not a reason to overplay.</li>
    </ul>

    <h2>Market trading risks</h2>
    <p>
      Market shares can gain or lose value before resolution. Liquidity, spreads, and settlement timing affect what you
      can buy, sell, or withdraw. Closing a position does not always mean instant withdrawable cash — on-chain settlement
      may take a short time. Check your Settling table and Wallet withdrawable balance.
    </p>

    <h2>Signs of problematic play</h2>
    <ul>
      <li>Chasing losses with larger stakes.</li>
      <li>Neglecting work, school, or relationships to play.</li>
      <li>Borrowing money or hiding activity from others.</li>
      <li>Feeling anxious or irritable when not playing.</li>
    </ul>

    <h2>Tools on WE R GAME</h2>
    <ul>
      <li>Free play limits and ticket periods set by platform administrators.</li>
      <li>Gas drip and claim cooldowns to reduce abusive patterns.</li>
      <li>Account verification and abuse detection systems.</li>
    </ul>

    <h2>Self-exclusion and support</h2>
    <p>
      If you need a break, contact support to request account restrictions or closure. If you or someone you know needs
      help with gambling-related harm, reach out to local responsible-gaming or mental-health resources in your country.
    </p>

    <h2>Minors</h2>
    <p>
      WE R GAME is strictly for adults. Do not allow minors to use your account or linked wallet.
    </p>
  </LegalPageLayout>
);

export default ResponsibleGaming;
